var _path, _circle, _circle2, _circle3, _path2, _ellipse;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgDevices = function SvgDevices(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    viewBox: "-103 -64.7 333 480.9",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230-22.2v-20c0-12.4-10.1-22.5-22.5-22.5h-288c-12.4 0-22.5 10.1-22.5 22.5V-.8c0 4.1 3.4 7.5 7.5 7.5S-88 3.3-88-.8v-41.4c0-4.1 3.4-7.5 7.5-7.5h288c4.1 0 7.5 3.4 7.5 7.5v292c0 4.1-3.4 7.5-7.5 7.5h-288c-4.1 0-7.5-3.4-7.5-7.5V31.2c0-4.1-3.4-7.5-7.5-7.5s-7.5 3.4-7.5 7.5v218.6c0 12.4 10.1 22.5 22.5 22.5h288c12.4 0 22.5-10.1 22.5-22.5v-272z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -26.7,
    cy: 185.1,
    r: 32.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 66.5,
    cy: 185.1,
    r: 32.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 155.7,
    cy: 185.1,
    r: 32.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5-1.1h-249c-3.8 0-7-3.1-7-7 0-3.8 3.1-7 7-7h249c3.9 0 7 3.1 7 7s-3.1 7-7 7zM187.5 28.9h-249c-3.8 0-7-3.1-7-7s3.1-7 7-7h249c3.9 0 7 3.1 7 7s-3.1 7-7 7zM187.5 59.9h-249c-3.8 0-7-3.1-7-7s3.1-7 7-7h249c3.9 0 7 3.1 7 7s-3.1 7-7 7zM62 406.9c4.1 0 7.5-3.4 7.5-7.5v-127c0-4.1-3.4-7.5-7.5-7.5s-7.5 3.4-7.5 7.5v127c0 4.1 3.4 7.5 7.5 7.5z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.5,
    cy: 403.7,
    rx: 66,
    ry: 12.5
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDevices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/devices.3b714642.svg";
export { ForwardRef as ReactComponent };